module.exports = __webpack_public_path__ + "static/media/literallyball.10fee3db.png";